webpackJsonp([1],{

/***/ "+aT9":
/***/ (function(module, exports) {

module.exports = AMap;

/***/ }),

/***/ "/TTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9i8G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y4Lg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cjcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AMap__ = __webpack_require__("+aT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_AMap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      // 地图start
      activeType: 0, //当前搜索类别的下标
      types: ["200300", //卫生间
      "150900", //停车场
      "050000", //美食
      //  "050000|050100|050101|050102|050103|050104|050105|050106|050107|050108|050109|050110|050111|050112|050113|050114|050115|050116|050117|050118|050119|050120|050121|050122|050123|050200|050201|050202|050203|050204|050205|050206|050207|050208|050209|050210|050211|050212|050213|050214|050215|050216|050217|050300|050301|050302|050303|050304|050305|050306|050307|050308|050309|050310|050311|050400|050500|050501|050502|050503|050504|050600|050700|050800|050900", //美食
      "100000"], //搜索的类别
      curMarkers: [], //当前点的合集
      mapObj: null, //地图实例
      leLayer: null, //瓦片实例
      mapMaxZoom: 19, //地图最大层级
      mapMinZoom: 13, //地图最小层级
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      toiletPois: null, //厕所点集合
      walk: null, //线路规划
      walkIdx: -1 //线路规划中的poi点的下标
      // 地图end
    };
  },

  //监听属性 类似于data概念
  computed: {
    // toiletPois: function() {}
  },
  //监控data中的数据变化
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // toiletPois: function(newV, oldV) {
    //     console.log('变化咯。。。。。。。。。')
    // }
  },
  //方法集合
  methods: {
    //   地图初始化
    initMap: function initMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Map("container", {
        view: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.View2D({
          //创建地图二维视口
          // center: new AMap.LngLat(
          //   sessionStorage.getItem("lng"),
          //   sessionStorage.getItem("lat")
          // ),
          zoom: 16, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 瓦片加载
      that.leLayer = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl: "https://daoyou.worldmaipu.com" + "/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]',
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]&hid=',
        zIndex: 2
      });
      //   that.leLayer.setMap(that.mapObj);
      // 缩放组件
      // that.mapObj.plugin(["AMap.ToolBar"], function() {
      //   that.mapObj.addControl(
      //     new AMap.ToolBar({
      //       position: "RB",
      //       //locate:true
      //       liteStyle: true,
      //       offset: new AMap.Pixel(10, 100)
      //     })
      //   );
      // });

      // if (that.GLOBAL.isWx) {
      //   // 微信环境
      //   setTimeout(() => {
      //     that.wxGetLocationOnce();
      //   }, 600);
      // } else {
      //   // 普通浏览器环境
      //   that.geolocation = new qq.maps.Geolocation(
      //     "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
      //     "myweb"
      //   );
      //   // 初始默认持续获取当前定位
      //   that.watchCurPosition();
      // }
      that.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 初始默认持续获取当前定位
      that.watchCurPosition();
    },

    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("on");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        that.clearWatchCurPosition();
        console.log(position);
        var lnglat = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(position.lng, position.lat);
        that.mapObj.setCenter(lnglat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        console.log(lnglat);
        if (that.isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.isLocation = true;
          that.locationMarker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
            position: lnglat,
            offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 101
          });
          that.mapObj.add(that.locationMarker);
        }
        that.searchToilet(position.lat, position.lng, that.activeType);
      }
    },

    // 微信中获取一次定位
    wxGetLocationOnce: function wxGetLocationOnce() {
      var that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function success(res) {
          // success
          console.log(res);
          var lat = res.latitude;
          var lng = res.longitude;
          // let lat = 36.195606;
          // let lng = 113.589566;
          var lnglat = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(lng, lat);
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.isLocation) {
            that.locationMarker.setPosition(lnglat);
          } else {
            that.isLocation = true;
            that.locationMarker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
              position: lnglat,
              offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-8, -16),
              content: "<div class='curMarker'></div>",
              zIndex: 101
            });
            that.mapObj.add(that.locationMarker);
          }
          that.searchToilet(lat, lng, that.activeType);
        },
        fail: function fail() {
          // fail
        },
        complete: function complete() {
          // complete
        }
      });
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      // this.mapObj.remove(this.locationMarker);
      // this.isLocation = false;
      // this.locationMarker = null;
    },


    //   搜索厕所poi
    searchToilet: function searchToilet(lat, lng, typeIndex) {
      var that = this;
      if (that.curMarkers.length > 0) {
        that.mapObj.remove(that.curMarkers);
        that.curMarkers = [];
      }
      var searchTypes = void 0;

      searchTypes = that.types[typeIndex];
      console.log(searchTypes);

      $.getJSON("https://restapi.amap.com/v3/place/around", {
        key: "c2526cf60981aa9faf0d2a8bab1b67bc",
        radius: 30000,
        types: that.types[typeIndex],
        location: lng + "," + lat,
        output: "JSON"
      }, function (res) {
        console.log(res);
        that.toiletPois = res.pois;
        that.setToiletPois(that.toiletPois, that.activeType);
        that.$nextTick(function () {
          document.getElementById("toiletBox").scrollTop = 0;
        });
      });
    },
    changType: function changType(i) {
      if (this.activeType == i) {
        return;
      } else {
        if (this.walk) {
          this.walk.clear();
        }
        this.walkIdx = -1;
        this.searchToilet(sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), i);
        this.activeType = i;
      }
    },
    setToiletPois: function setToiletPois(arr, type) {
      var that = this;
      var contentHtml = "";
      switch (parseInt(type)) {
        case 0:
          contentHtml = "<div class='search-toilet'></div>";
          break;
        case 1:
          contentHtml = "<div class='search-park'></div>";

          break;
        case 2:
          contentHtml = "<div class='gas-station'></div>";

          break;
        case 3:
          contentHtml = "<div class='search-stop'></div>";
          break;
        case 4:
          contentHtml = "<div class='search-hospital'></div>";
          break;
      }
      for (var i in arr) {
        var marker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
          // map: that.mapObj,
          position: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(arr[i].location.split(",")[0], arr[i].location.split(",")[1]),
          offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-16, -32),
          content: contentHtml,
          extData: {
            index: i
          }
        });
        // that.mapObj.add(marker);
        __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.event.addListener(marker, "click", function (e) {
          that.walkIdx = e.target.getExtData().index;
          var lat = e.target.getPosition().lat;
          var lng = e.target.getPosition().lng;
          __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.service("AMap.Walking", function () {
            if (that.walk) {
              that.walk.clear();
            }
            that.walk = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Walking({
              map: that.mapObj
              //用于显示路线指引信息的Div容器的id或Div元素
              //panel: "panel"
            });
            // 根据起终点经纬度规划驾车导航路线
            that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
              // console.log(result);
              if (status === "complete" && result.info === "OK") {
                that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
              }
            });
          });
          console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
          // 规划中的厕所点的对应dom滚动到顶部
          document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
        });
        that.curMarkers.push(marker);
      }
      that.mapObj.add(that.curMarkers);
      that.mapObj.setFitView();
    },

    // 规划线路 和点位点击事件相同
    drawWlak: function drawWlak(item, i) {
      var that = this;
      that.walkIdx = i;
      var lat = item.location.split(",")[1];
      var lng = item.location.split(",")[0];
      __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.service("AMap.Walking", function () {
        if (that.walk) {
          that.walk.clear();
        }
        that.walk = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Walking({
          map: that.mapObj
          //用于显示路线指引信息的Div容器的id或Div元素
          //panel: "panel"
        });
        // 根据起终点经纬度规划驾车导航路线
        that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
          // console.log(result);
          if (status === "complete" && result.info === "OK") {
            that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
          }
        });
      });
      console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
      // 规划中的厕所点的对应dom滚动到顶部
      document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.initMap();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Do6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PositionBtn/PositionBtn.vue
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var PositionBtn = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      this_isLocation: false, //成功展示定位点了
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 },
      curPositionInterval: null //微信中获取定位的定时器
    };
  },

  props: {
    isLocation: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    scenicBound: {
      type: Array
    },
    mapObj: {
      type: Object
    },
    needZoomTo: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    isLocation: function isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
        // }
      }
    }
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("持续定位开始");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        var lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            // $.toast("您当前不在景区范围内", "text");
            that.$vux.toast.text("您当前不在景区范围内", "bottom");
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },

    // 是否在一个电子围栏内
    isInBound: function isInBound(lat, lng, bound) {
      var polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0 //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },

    // 定位开关
    onOff: function onOff() {
      if (this.this_isLocation) {
        // 关
        this.clearWatchCurPosition();
      } else {
        // 开
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
        // }
      }
    },

    // 微信中 单次定位
    wxGetPositionOnce: function wxGetPositionOnce() {
      var that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function success(res) {
          // success
          console.log(res);
          var lat = res.latitude;
          var lng = res.longitude;
          // let lat = 36.195606;
          // let lng = 113.589566;
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.scenicBound.length > 0) {
            console.log("有电子围栏");
            if (that.isInBound(lat, lng, that.scenicBound)) {
              console.log("在景区内");
              // 用户在景区内就以用户为中心点
              that.mapObj.setCenter([lng, lat]);
            } else {
              that.$vux.toast.text("您当前不在景区范围内", "bottom");
              console.log("不在景区内");
              return;
            }
          } else {
            console.log("没有电子围栏");
          }
          that.wxWatchCurPosition();
        },
        fail: function fail() {
          // fail
        },
        complete: function complete() {
          // complete
        }
      });
    },

    // 微信中连续定位事件
    wxWatchCurPosition: function wxWatchCurPosition() {
      var that = this;
      // let lat = 36.195606;
      // let lng = 113.589566;
      this.curPositionInterval = setInterval(function () {
        console.log("当前微信定位定时器中");
        that.$wechat.getLocation({
          type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
          success: function success(res) {
            // success
            console.log(res);
            var lat = res.latitude;
            var lng = res.longitude;
            // lat+=0.001;
            sessionStorage.setItem("lng", lng);
            sessionStorage.setItem("lat", lat);
            if (that.scenicBound.length > 0) {
              console.log("有电子围栏");
              if (that.isInBound(lat, lng, that.scenicBound)) {
                console.log("在电子围栏内");
              } else {
                console.log("不在电子围栏内");
                that.$vux.toast.text("您当前不在景区范围内", "bottom");
                that.clearWatchCurPosition();
                return;
              }
            } else {
              console.log("没有电子围栏");
            }
            if (that.this_isLocation) {
              that.locationMarker.setPosition([lng, lat]);
            } else {
              that.this_isLocation = true;
              that.locationMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                offset: new AMap.Pixel(-8, -16),
                content: "<div class='curMarker'></div>",
                zIndex: 200
              });
              that.mapObj.add(that.locationMarker);
            }
          },
          fail: function fail() {
            // fail
          },
          complete: function complete() {
            // complete
          }
        });
        // thislat += 0.01;
      }, 1000);
    },

    // 单次定位 获取定位成功事件
    showPosition: function showPosition(position) {
      console.log("首次定位成功");
      // this.$vux.toast.text("首次定位成功");
      console.log(position);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
          // 用户在景区内就以用户为中心点
          this.mapObj.setCenter([position.lng, position.lat]);
        } else {
          console.log("不在电子围栏内");
          // $.toast("您当前不在景区范围内", "text");
          this.$vux.toast.text("您当前不在景区范围内", "bottom");
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },

    // 单次定位 获取定位失败事件
    showErr: function showErr() {
      console.log("首次定位失败");
      this.$vux.toast.text("获取定位失败", "bottom");
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      if (this.GLOBAL.isWx) {
        clearInterval(this.curPositionInterval);
        this.curPositionInterval = null;
      } else {
        this.geolocation.clearWatch();
      }
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    // if (this.GLOBAL.isWx) {
    // } else {
    this.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
    // }
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  },
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PositionBtn/PositionBtn.vue
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var PositionBtn_PositionBtn = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      this_isLocation: false, //成功展示定位点了
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 },
      curPositionInterval: null //微信中获取定位的定时器
    };
  },

  props: {
    isLocation: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    scenicBound: {
      type: Array
    },
    mapObj: {
      type: Object
    },
    needZoomTo: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    isLocation: function isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
        // }
      }
    }
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("持续定位开始");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        var lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            // $.toast("您当前不在景区范围内", "text");
            that.$vux.toast.text("您当前不在景区范围内", "bottom");
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },

    // 是否在一个电子围栏内
    isInBound: function isInBound(lat, lng, bound) {
      var polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0 //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },

    // 定位开关
    onOff: function onOff() {
      if (this.this_isLocation) {
        // 关
        this.clearWatchCurPosition();
      } else {
        // 开
        // if (this.GLOBAL.isWx) {
        //   this.wxGetPositionOnce();
        // } else {
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
        // }
      }
    },

    // 微信中 单次定位
    wxGetPositionOnce: function wxGetPositionOnce() {
      var that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function success(res) {
          // success
          console.log(res);
          var lat = res.latitude;
          var lng = res.longitude;
          // let lat = 36.195606;
          // let lng = 113.589566;
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.scenicBound.length > 0) {
            console.log("有电子围栏");
            if (that.isInBound(lat, lng, that.scenicBound)) {
              console.log("在景区内");
              // 用户在景区内就以用户为中心点
              that.mapObj.setCenter([lng, lat]);
            } else {
              that.$vux.toast.text("您当前不在景区范围内", "bottom");
              console.log("不在景区内");
              return;
            }
          } else {
            console.log("没有电子围栏");
          }
          that.wxWatchCurPosition();
        },
        fail: function fail() {
          // fail
        },
        complete: function complete() {
          // complete
        }
      });
    },

    // 微信中连续定位事件
    wxWatchCurPosition: function wxWatchCurPosition() {
      var that = this;
      // let lat = 36.195606;
      // let lng = 113.589566;
      this.curPositionInterval = setInterval(function () {
        console.log("当前微信定位定时器中");
        that.$wechat.getLocation({
          type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
          success: function success(res) {
            // success
            console.log(res);
            var lat = res.latitude;
            var lng = res.longitude;
            // lat+=0.001;
            sessionStorage.setItem("lng", lng);
            sessionStorage.setItem("lat", lat);
            if (that.scenicBound.length > 0) {
              console.log("有电子围栏");
              if (that.isInBound(lat, lng, that.scenicBound)) {
                console.log("在电子围栏内");
              } else {
                console.log("不在电子围栏内");
                that.$vux.toast.text("您当前不在景区范围内", "bottom");
                that.clearWatchCurPosition();
                return;
              }
            } else {
              console.log("没有电子围栏");
            }
            if (that.this_isLocation) {
              that.locationMarker.setPosition([lng, lat]);
            } else {
              that.this_isLocation = true;
              that.locationMarker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat),
                offset: new AMap.Pixel(-8, -16),
                content: "<div class='curMarker'></div>",
                zIndex: 200
              });
              that.mapObj.add(that.locationMarker);
            }
          },
          fail: function fail() {
            // fail
          },
          complete: function complete() {
            // complete
          }
        });
        // thislat += 0.01;
      }, 1000);
    },

    // 单次定位 获取定位成功事件
    showPosition: function showPosition(position) {
      console.log("首次定位成功");
      // this.$vux.toast.text("首次定位成功");
      console.log(position);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
          // 用户在景区内就以用户为中心点
          this.mapObj.setCenter([position.lng, position.lat]);
        } else {
          console.log("不在电子围栏内");
          // $.toast("您当前不在景区范围内", "text");
          this.$vux.toast.text("您当前不在景区范围内", "bottom");
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },

    // 单次定位 获取定位失败事件
    showErr: function showErr() {
      console.log("首次定位失败");
      this.$vux.toast.text("获取定位失败", "bottom");
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      if (this.GLOBAL.isWx) {
        clearInterval(this.curPositionInterval);
        this.curPositionInterval = null;
      } else {
        this.geolocation.clearWatch();
      }
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    // if (this.GLOBAL.isWx) {
    // } else {
    this.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
    // }
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  },
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61b15534","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PositionBtn/PositionBtn.vue
var PositionBtn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['position-btn',_vm.this_isLocation?'on':''],on:{"click":function($event){return _vm.onOff()}}})}
var staticRenderFns = []
var esExports = { render: PositionBtn_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_PositionBtn_PositionBtn = (esExports);
// CONCATENATED MODULE: ./src/components/PositionBtn/PositionBtn.vue
function injectStyle (ssrContext) {
  __webpack_require__("/TTU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61b15534"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PositionBtn_PositionBtn,
  components_PositionBtn_PositionBtn,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_PositionBtn_PositionBtn = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Index/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

// 定位按钮

/* harmony default export */ var Index = ({
  //import引入的组件需要注入到对象中才能使用
  components: { PositionBtn: src_components_PositionBtn_PositionBtn },
  data: function data() {
    //这里存放数据
    return {
      hid: 41190, //全域的hid
      scenicses: null,
      scenicPoi: [], //景点
      curMarkers: [], //当前地图中的点位
      activeScenicPoiData: null, //点击景点的数据
      myAudioSrc: null, //音频地址
      playing: false, //景点弹窗中音频播放状态
      mapObj: null,
      leLayer: null,
      scenicLng: 121.352056, //景区经纬度
      scenicLat: 29.236773, //景区经纬度
      mapMinZoom: 10,
      mapMaxZoom: 15,
      scenicBound: [[121.418965, 29.285191], [121.418965, 29.181659], [121.221479, 29.181659], [121.221479, 29.285191]],
      isLocation: false //是否展示当前定位了
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //获取全域所有点位信息
    getScenics: function getScenics() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!findScenics.action",
        params: {},
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          // 处理poi点层级数组数据
          function getPoiList(Arr) {
            var zoomRange = parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom); //层级差
            for (var j = 0; j < zoomRange + 1; j++) {
              var arr = [];
              Arr.push(arr);
            }
          }
          getPoiList(that.scenicPoi);
          that.setPois(data.data.points, that.mapMinZoom, that.mapMaxZoom);
          that.addPoi();
          that.scenicses = data.data.scenicses;
          for (var i in that.scenicses) {
            // 展示默认点位
            var marker = new AMap.Marker({
              map: that.mapObj,
              position: new AMap.LngLat(that.scenicses[i].longitude, that.scenicses[i].latitude),
              content: "<div class='scenic'><div class='scenic-out'><img class='iconall' id='scenic" + "' src='" + that.GLOBAL.DOMAIN_URL + that.scenicses[i].thumbImg + "'></div><span class='scenicName'>" + that.scenicses[i].name + "</span></div>",
              offset: new AMap.Pixel(-24, -48),
              extData: {
                hid: that.scenicses[i].id
              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var extData = e.target.getExtData();
              that.$router.push({
                path: "/scenic",
                name: "scenic",
                query: { hid: extData.hid }
              });
            });
          }
        }
      });
    },

    // 处理poi点数据
    setPois: function setPois(pointses, mapMin, mapMax) {
      var that = this;
      // debugger

      for (var i in pointses) {
        // 最大缩放层级
        var max_zoom = pointses[i].max_zoom;
        // 最小缩放层级
        var min_zoom = pointses[i].min_zoom;
        var poiZoomRange = mapMax - mapMin;
        // console.log(i)
        // 语音点
        var marker = that.creatMarker(pointses[i]);
        AMap.event.addListener(marker, "click", function (e) {
          console.log(e.target.getExtData());
          that.activeScenicPoiData = e.target.getExtData().poiData;
          // that.myAudioSrc=this.activeScenicPoiData.audio;
          // that.mapObj
          that.playing = false;
          if (e.target.getExtData().poiData.audio != null) {
            that.myAudioSrc = that.GLOBAL.DOMAIN_URL + e.target.getExtData().poiData.audio.split(".")[0] + ".mp3";
          } else {
            that.myAudioSrc = null;
          }

          if (that.myAudioSrc != null) {
            document.getElementById("myAudio").load();
          }
        });
        var min = min_zoom - mapMin;
        for (var z = 0; z < poiZoomRange + 1; z++) {
          if (z >= min) {
            that.scenicPoi[z].push(marker);
          }
        }
      }
    },

    // 生成各个类别的poi点
    creatMarker: function creatMarker(point) {
      var that = this;
      var className = void 0;
      var offset = new AMap.Pixel(-16, -32);
      switch (Number(point.type)) {
        case 2:
          className = "talk";
          //  content =
          // "<div class='poi'><div class='talk iconall'></div><span class='poiName'>" +
          // point.chs_name +
          // "</span></div>";
          offset = new AMap.Pixel(-16, -16);
          break;
      }
      var thisPoi = new AMap.Marker({
        content: "<div class='poi'><div class='" + className + " iconall'></div><span class='poiName talk'>" + point.chs_name + "</span></div>",
        position: new AMap.LngLat(point.longitude, point.latitude),
        // icon: "./data/btns/marker.png",
        offset: offset,
        extData: {
          poiData: point
        }
      });
      return thisPoi;
    },

    // 加载地图
    setMap: function setMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          // 创建地图二维视口
          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: 13, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 景区电子围栏
      // for (let i in that.scenicData.polygons) {
      //   that.scenicBound.push([
      //     that.scenicData.polygons[i].longitude,
      //     that.scenicData.polygons[i].latitude
      //   ]);
      // }
      that.getScenics();

      // 瓦片加载
      that.leLayer = new AMap.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl:
        // "https://pingshun.worldmaipu.com/upload_resources/tile/" +
        // that.hid +
        // "/[z]/[x]_[y].png",
        "https://tiles.worldmaipu.com/global/" + 52980 + "/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      // 开始定位
      that.isLocation = true; //定位组件 定位事件
      that.mapObj.on("complete", function () {
        console.log("地图加载完毕");
      });

      // 监听地图缩放结束事件
      AMap.event.addListener(that.mapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.mapObj.getZoom());
        that.addPoi();
      });

      // 监听地图点击事件
      AMap.event.addListener(that.mapObj, "click", function (e) {
        console.log("点击地图");
        console.log(e.lnglat);
      });
      // 加载插件
      // 缩放组件
      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "LB",
          //locate:true
          liteStyle: true,
          offset: new AMap.Pixel(10, 200)
        }));
      });
    },

    // 添加点位
    addPoi: function addPoi() {
      console.log("addPoi");
      this.mapObj.remove(this.curMarkers);
      // 语音点播放窗关闭 start
      // this.activeScenicPoiData = null;
      // if (!document.getElementById("myAudio").paused) {
      //   this.playing = false;
      //   this.myAudioSrc = null;
      //   document.getElementById("myAudio").pause();
      // }
      // 语音点播放窗关闭 end
      var zoom = this.mapObj.getZoom();
      // if (lanType == 1) {

      this.curMarkers = this.scenicPoi[zoom - this.mapMinZoom];

      this.mapObj.add(this.curMarkers);
    },


    // 播放景点的音频
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    // this.getScenics();
    this.setMap();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Index/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

// 定位按钮

/* harmony default export */ var Index_Index = ({
  //import引入的组件需要注入到对象中才能使用
  components: { PositionBtn: src_components_PositionBtn_PositionBtn },
  data: function data() {
    //这里存放数据
    return {
      hid: 41190, //全域的hid
      scenicses: null,
      scenicPoi: [], //景点
      curMarkers: [], //当前地图中的点位
      activeScenicPoiData: null, //点击景点的数据
      myAudioSrc: null, //音频地址
      playing: false, //景点弹窗中音频播放状态
      mapObj: null,
      leLayer: null,
      scenicLng: 121.352056, //景区经纬度
      scenicLat: 29.236773, //景区经纬度
      mapMinZoom: 10,
      mapMaxZoom: 15,
      scenicBound: [[121.418965, 29.285191], [121.418965, 29.181659], [121.221479, 29.181659], [121.221479, 29.285191]],
      isLocation: false //是否展示当前定位了
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //获取全域所有点位信息
    getScenics: function getScenics() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!findScenics.action",
        params: {},
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          // 处理poi点层级数组数据
          function getPoiList(Arr) {
            var zoomRange = parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom); //层级差
            for (var j = 0; j < zoomRange + 1; j++) {
              var arr = [];
              Arr.push(arr);
            }
          }
          getPoiList(that.scenicPoi);
          that.setPois(data.data.points, that.mapMinZoom, that.mapMaxZoom);
          that.addPoi();
          that.scenicses = data.data.scenicses;
          for (var i in that.scenicses) {
            // 展示默认点位
            var marker = new AMap.Marker({
              map: that.mapObj,
              position: new AMap.LngLat(that.scenicses[i].longitude, that.scenicses[i].latitude),
              content: "<div class='scenic'><div class='scenic-out'><img class='iconall' id='scenic" + "' src='" + that.GLOBAL.DOMAIN_URL + that.scenicses[i].thumbImg + "'></div><span class='scenicName'>" + that.scenicses[i].name + "</span></div>",
              offset: new AMap.Pixel(-24, -48),
              extData: {
                hid: that.scenicses[i].id
              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var extData = e.target.getExtData();
              that.$router.push({
                path: "/scenic",
                name: "scenic",
                query: { hid: extData.hid }
              });
            });
          }
        }
      });
    },

    // 处理poi点数据
    setPois: function setPois(pointses, mapMin, mapMax) {
      var that = this;
      // debugger

      for (var i in pointses) {
        // 最大缩放层级
        var max_zoom = pointses[i].max_zoom;
        // 最小缩放层级
        var min_zoom = pointses[i].min_zoom;
        var poiZoomRange = mapMax - mapMin;
        // console.log(i)
        // 语音点
        var marker = that.creatMarker(pointses[i]);
        AMap.event.addListener(marker, "click", function (e) {
          console.log(e.target.getExtData());
          that.activeScenicPoiData = e.target.getExtData().poiData;
          // that.myAudioSrc=this.activeScenicPoiData.audio;
          // that.mapObj
          that.playing = false;
          if (e.target.getExtData().poiData.audio != null) {
            that.myAudioSrc = that.GLOBAL.DOMAIN_URL + e.target.getExtData().poiData.audio.split(".")[0] + ".mp3";
          } else {
            that.myAudioSrc = null;
          }

          if (that.myAudioSrc != null) {
            document.getElementById("myAudio").load();
          }
        });
        var min = min_zoom - mapMin;
        for (var z = 0; z < poiZoomRange + 1; z++) {
          if (z >= min) {
            that.scenicPoi[z].push(marker);
          }
        }
      }
    },

    // 生成各个类别的poi点
    creatMarker: function creatMarker(point) {
      var that = this;
      var className = void 0;
      var offset = new AMap.Pixel(-16, -32);
      switch (Number(point.type)) {
        case 2:
          className = "talk";
          //  content =
          // "<div class='poi'><div class='talk iconall'></div><span class='poiName'>" +
          // point.chs_name +
          // "</span></div>";
          offset = new AMap.Pixel(-16, -16);
          break;
      }
      var thisPoi = new AMap.Marker({
        content: "<div class='poi'><div class='" + className + " iconall'></div><span class='poiName talk'>" + point.chs_name + "</span></div>",
        position: new AMap.LngLat(point.longitude, point.latitude),
        // icon: "./data/btns/marker.png",
        offset: offset,
        extData: {
          poiData: point
        }
      });
      return thisPoi;
    },

    // 加载地图
    setMap: function setMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          // 创建地图二维视口
          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: 13, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 景区电子围栏
      // for (let i in that.scenicData.polygons) {
      //   that.scenicBound.push([
      //     that.scenicData.polygons[i].longitude,
      //     that.scenicData.polygons[i].latitude
      //   ]);
      // }
      that.getScenics();

      // 瓦片加载
      that.leLayer = new AMap.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl:
        // "https://pingshun.worldmaipu.com/upload_resources/tile/" +
        // that.hid +
        // "/[z]/[x]_[y].png",
        "https://tiles.worldmaipu.com/global/" + 52980 + "/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.mapObj);

      // 开始定位
      that.isLocation = true; //定位组件 定位事件
      that.mapObj.on("complete", function () {
        console.log("地图加载完毕");
      });

      // 监听地图缩放结束事件
      AMap.event.addListener(that.mapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.mapObj.getZoom());
        that.addPoi();
      });

      // 监听地图点击事件
      AMap.event.addListener(that.mapObj, "click", function (e) {
        console.log("点击地图");
        console.log(e.lnglat);
      });
      // 加载插件
      // 缩放组件
      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "LB",
          //locate:true
          liteStyle: true,
          offset: new AMap.Pixel(10, 200)
        }));
      });
    },

    // 添加点位
    addPoi: function addPoi() {
      console.log("addPoi");
      this.mapObj.remove(this.curMarkers);
      // 语音点播放窗关闭 start
      // this.activeScenicPoiData = null;
      // if (!document.getElementById("myAudio").paused) {
      //   this.playing = false;
      //   this.myAudioSrc = null;
      //   document.getElementById("myAudio").pause();
      // }
      // 语音点播放窗关闭 end
      var zoom = this.mapObj.getZoom();
      // if (lanType == 1) {

      this.curMarkers = this.scenicPoi[zoom - this.mapMinZoom];

      this.mapObj.add(this.curMarkers);
    },


    // 播放景点的音频
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    // this.getScenics();
    this.setMap();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42899ad0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('audio',{attrs:{"src":_vm.myAudioSrc,"id":"myAudio"}}),_vm._v(" "),_c('div',{attrs:{"id":"container"}}),_vm._v(" "),_c('div',{staticClass:"rt-btns"},[_c('router-link',{staticClass:"rt-btn near",attrs:{"to":"/near"}})],1),_vm._v(" "),_c('PositionBtn',{attrs:{"isLocation":_vm.isLocation,"scenicBound":_vm.scenicBound,"mapObj":_vm.mapObj}}),_vm._v(" "),(_vm.activeScenicPoiData != null)?_c('div',{staticClass:"talk-pop"},[_c('div',{staticClass:"talk-player",on:{"click":function($event){return _vm.playScenicAudio()}}},[_c('div',{class:['player-box', _vm.playing ? 'on' : ''],style:({
          'background-image':
            'url(' + _vm.GLOBAL.DOMAIN_URL + _vm.activeScenicPoiData.thumbImg + ')',
        })},[_c('i')])]),_vm._v(" "),_c('div',{staticClass:"talk-content"},[_c('router-link',{staticClass:"talk-name ellipsis-1",attrs:{"to":{ path: 'scenicDetail', query: { id: _vm.activeScenicPoiData.hid } }}},[_vm._v(_vm._s(_vm.activeScenicPoiData.chs_name))]),_vm._v(" "),_c('div',{staticClass:"nav",on:{"click":function($event){return _vm.nav(
            _vm.activeScenicPoiData.chs_name,
            _vm.activeScenicPoiData.latitude,
            _vm.activeScenicPoiData.longitude
          )}}},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',[_vm._v("导航")])])],1)]):_vm._e()],1)}
var Index_staticRenderFns = []
var Index_esExports = { render: Index_render, staticRenderFns: Index_staticRenderFns }
/* harmony default export */ var pages_Index_Index = (Index_esExports);
// CONCATENATED MODULE: ./src/pages/Index/Index.vue
function Index_injectStyle (ssrContext) {
  __webpack_require__("iJUh")
  __webpack_require__("woim")
}
var Index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = Index_injectStyle
/* scopeId */
var Index___vue_scopeId__ = "data-v-42899ad0"
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null
var Index_Component = Index_normalizeComponent(
  Index_Index,
  pages_Index_Index,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var src_pages_Index_Index = (Index_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("gWrV")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Scenic/Scenic.vue







/* harmony default export */ var Scenic = ({

  components: { PositionBtn: src_components_PositionBtn_PositionBtn, Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {

    return {
      hid: this.$route.query.hid,
      scenicData: null, //景区所有数据
      scenicMapObj: null, //地图实例
      leLayer: null,
      isleLayerShow: true, //瓦片是否展示
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //电子围栏
      isInLine: false, //是否在线路中
      lines: [], //线路所有数据
      activeLineIdx: -1, //选中的线路下标
      activeLineSpotIdx: -1, //选中的线路的选中点的下标
      polyline: null, //线路中的线
      isNearListShow: false, //附近点列表是否展示
      mapMinZoom: 13,
      mapMaxZoom: 18,

      isLineListShow: false, //是否展示线路列表

      poiType: [],
      activePoiTypeId: null, //选中展示的poi类别
      scenicPoi: [],
      parkPoi: [],
      toiletPoi: [],
      catePoi: [],
      hotelPoi: [],
      shopPoi: [],
      servicePoi: [],
      curMarkers: [], //当前地图中的点位
      playing: false, //景点弹窗中音频播放状态
      activeScenicPoiData: null, //点击景点的数据
      myAudioSrc: null, //音频地址

      swiperItemIndex: 0

    };
  },


  computed: {
    activePoiTypeIndex: function activePoiTypeIndex() {
      if (this.poiType == null) {
        return null;
      } else {
        for (var i in this.poiType) {
          if (this.poiType[i].id == this.activePoiTypeId) {
            return i;
          }
        }
      }
    }
  },

  watch: {},

  methods: {
    getScenicData: function getScenicData() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
        params: { hid: that.hid },
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          that.scenicData = data.data.data.scenic;
          document.title = data.data.data.scenic.name;

          function getPoiList(Arr) {
            var zoomRange = parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom);
            for (var j = 0; j < zoomRange + 1; j++) {
              var arr = [];
              Arr.push(arr);
            }
          }

          that.setPoiType(data.data.data.navTabs);
          that.setPois(data.data.data.scenic.pointses);

          that.setMap();

          that.setLine(data.data.data.scenic.hotspotLinesList);
        }
      });
    },
    setMap: function setMap() {
      var that = this;

      that.scenicMapObj = new AMap.Map("scenicMap", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicData.longitude, that.scenicData.latitude),
          zoom: that.scenicData.min_zoom, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });

      for (var i in that.scenicData.polygons) {
        that.scenicBound.push([that.scenicData.polygons[i].longitude, that.scenicData.polygons[i].latitude]);
      }

      var maipuLeLayerId = void 0;
      switch (parseInt(that.hid)) {
        case 18:
          maipuLeLayerId = 53004;
          break;
        case 17:
          maipuLeLayerId = 4249;
          break;
      }
      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://tiles.worldmaipu.com/" + maipuLeLayerId + "/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.scenicMapObj);

      that.isLocation = true;
      that.scenicMapObj.on("complete", function () {
        console.log("地图加载完毕");
      });

      for (var j in that.poiType) {
        if (that.poiType[j].isHasPoi) {
          that.activePoiTypeId = that.poiType[j].id;

          break;
        }
      }
      console.log(that.poiType[that.activePoiTypeIndex]);
      for (var z in that.poiType[that.activePoiTypeIndex].types) {
        that.curMarkers = that.curMarkers.concat(that.poiType[that.activePoiTypeIndex].types[z].markerArr[that.scenicMapObj.getZoom() - that.mapMinZoom]);
        console.log(that.curMarkers);
      }
      console.log(that.curMarkers);
      if (that.curMarkers == undefined || that.curMarkers.length == 0) {} else {
        that.scenicMapObj.add(that.curMarkers);
      }

      AMap.event.addListener(that.scenicMapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.scenicMapObj.getZoom());
        that.mapMoveEnd();
      });

      AMap.event.addListener(that.scenicMapObj, "click", function (e) {
        console.log("点击地图");
        console.log(e.lnglat);
      });

      that.scenicMapObj.plugin(["AMap.ToolBar"], function () {
        that.scenicMapObj.addControl(new AMap.ToolBar({
          position: "LB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 200)
        }));
      });
    },
    setPoiType: function setPoiType(arr) {
      var that = this;
      for (var i in arr) {
        var obj = {};
        obj.id = arr[i].typeId;
        obj.name = arr[i].typeName;
        obj.icon = that.GLOBAL.DOMAIN_URL + arr[i].icon;
        obj.picth_icon = that.GLOBAL.DOMAIN_URL + arr[i].picthIcon;

        obj.types = [];
        for (var j in arr[i].navItems) {
          var sortObj = {};
          sortObj.pointIcon = that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointIcon;
          sortObj.id = arr[i].navItems[j].typeId;
          sortObj.pointPicthIcon = that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointPicthIcon;
          sortObj.markerArr = [];
          sortObj.typeName = arr[i].navItems[j].typeName;
          for (var z = that.mapMinZoom; z <= that.mapMaxZoom; z++) {
            sortObj.markerArr.push([]);
          }
          obj.types.push(sortObj);
        }
        obj.isHasPoi = false;
        that.poiType.push(obj);
      }
    },
    // 处理生成poi点 isScenicPoi是否是景点
    openLayer: function openLayer() {
      if (this.isleLayerShow == false) {
        this.leLayer.setMap(this.scenicMapObj);
      } else {
        this.scenicMapObj.remove(this.leLayer);
      }
      this.isleLayerShow = !this.isleLayerShow;
    },
    setPois: function setPois(pointses) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in pointses) {

        var max_zoom = pointses[i].max_zoom;

        var min_zoom = pointses[i].min_zoom;
        var icon_default = void 0;
        var typeIndex = void 0;
        var typeIdx = void 0;
        var isHasThisType = false;
        for (var j in that.poiType) {
          for (var z in that.poiType[j].types) {
            if (pointses[i].type == that.poiType[j].types[z].id) {
              icon_default = that.poiType[j].types[z].pointIcon;

              typeIndex = j;
              typeIdx = z;
              isHasThisType = true;
              that.poiType[j].isHasPoi = true;
              break;
            }
          }
        }

        if (!isHasThisType) {
          continue;
        }
        var marker = new AMap.Marker({
          position: new AMap.LngLat(pointses[i].longitude, pointses[i].latitude),
          content: "<div class='poi' id='poi" + i + "'><img class='iconall icon-default' src='" + icon_default + "'><span class='poiName'>" + pointses[i].chs_name + "</span></div>",
          offset: new AMap.Pixel(-23, -46),
          extData: {
            poiData: pointses[i]
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          this.setTop(true);

          that.poiMarkerFun(this);
        });
        var min = pointses[i].min_zoom - that.mapMinZoom;
        for (var _z = 0; _z < poiZoomRange + 1; _z++) {
          if (_z >= min) {
            that.poiType[typeIndex].types[typeIdx].markerArr[_z].push(marker);
          }
        }
      }
    },
    creatMarker: function creatMarker(point) {
      var that = this;
      var className = void 0;
      var offset = new AMap.Pixel(-16, -32);
      switch (Number(point.type)) {
        case 2:
          className = "talk";

          offset = new AMap.Pixel(-16, -16);
          break;
        case 9:
          className = "parking";
          break;
        case 6:
          className = "toilet";
          break;
        case 8:
          className = "cate";
          break;
        case 5:
          className = "hotel";
          break;
        case 12:
          className = "shopping";
          break;
        case 10:
          className = "service";
          break;
      }
      var thisPoi = new AMap.Marker({
        content: "<div class='poi'><div class='" + className + " iconall'></div><span class='poiName'>" + point.chs_name + "</span></div>",
        position: new AMap.LngLat(point.longitude, point.latitude),

        offset: offset,
        extData: {
          poiData: point
        }
      });
      return thisPoi;
    },
    poiMarkerFun: function poiMarkerFun(_this) {
      var that = this;
      var position = _this.getPosition();
      var extData = _this.getExtData();
      console.log(extData);

      if (that.activePoiTypeId == 1) {
        that.activeScenicPoiData = extData.poiData;
        that.playing = false;

        if (extData.poiData.audio != null) {
          that.myAudioSrc = that.GLOBAL.DOMAIN_URL + extData.poiData.audio.split(".")[0] + ".mp3";
        } else {
          that.myAudioSrc = null;
        }

        if (that.myAudioSrc != null) {
          document.getElementById("myAudio").load();
        }
      } else {

        console.log("poiMarkerFun -> extData.chs_name", extData.poiData.chs_name);
        console.log("poiMarkerFun -> " + sessionStorage.getItem("lat"));
        console.log("poiMarkerFun -> " + sessionStorage.getItem("lng"));
        console.log("poiMarkerFun -> extData.latitude", extData.poiData.latitude);
        console.log("poiMarkerFun -> extData.longitude", extData.poiData.longitude);
        that.nav(extData.poiData.chs_name, extData.poiData.latitude, extData.poiData.longitude);
      }
    },
    setLine: function setLine(linesList) {
      var that = this;
      for (var i in linesList) {
        var obj = {};
        obj.lineName = linesList[i].lineName;
        obj.lineDuration = linesList[i].reserved3;
        obj.lineSpots = linesList[i].reserved4;
        obj.id = linesList[i].id;
        obj.coordinateList = [];
        obj.linePois = [];
        obj.lineMarkers = [];
        var z = 1;
        for (var n in linesList[i].coordinateList) {
          obj.linePois.push(new AMap.LngLat(Number(linesList[i].coordinateList[n].longitude), Number(linesList[i].coordinateList[n].latitude)));
          if (linesList[i].coordinateList[n].reserved1.indexOf("默认") == -1) {

            obj.coordinateList.push(linesList[i].coordinateList[n]);
            var marker = new AMap.Marker({
              content: "<div class='line-poi'><div class='line-marker' number='" + n + "'>" + z + "</div><span class='poiName'>" + linesList[i].coordinateList[n].reserved1 + "</span></div>",
              position: new AMap.LngLat(linesList[i].coordinateList[n].longitude, linesList[i].coordinateList[n].latitude),

              offset: new AMap.Pixel(-23, -46),
              extData: {
                poiData: linesList[i].coordinateList[n],
                index: z - 1
              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var thisPosition = e.target.getPosition();
              var extData = e.target.getExtData().poiData;
              var index = e.target.getExtData().index;
              that.linePoiClick(thisPosition, extData, index);
              that.activeLineSpotIdx = index;
              that.swiperItemIndex = parseInt(index) + 1;
            });

            obj.lineMarkers.push(marker);
            z++;
          }
        }
        that.lines.push(obj);
      }
      console.log(that.lines);
    },
    linePoiClick: function linePoiClick(thisPosition, extData) {
      console.log(extData);
      this.playing = false;
      if (extData.audio != null) {
        this.myAudioSrc = this.GLOBAL.DOMAIN_URL + extData.audio.split(".")[0] + ".mp3";
      } else {
        this.myAudioSrc = null;
      }

      if (this.myAudioSrc != null) {
        document.getElementById("myAudio").load();
      }

      this.scenicMapObj.setCenter(thisPosition);
    },
    lineTrigger: function lineTrigger() {
      if (this.isLineListShow) {

        this.isLineListShow = false;
        this.activeLineIdx = -1;
        if (this.isInLine) {
          if (!document.getElementById("myAudio").paused) {
            document.getElementById("myAudio").pause();
            this.playing = false;
          }
          this.isInLine = false;
          this.scenicMapObj.remove(this.polyline);
          this.mapMoveEnd();
        }
      } else {

        this.isLineListShow = true;
      }
    },
    showLine: function showLine(i) {
      this.activeLineIdx = i;
      console.log(i);
      this.scenicMapObj.remove(this.curMarkers);

      this.activeScenicPoiData = null;
      if (!document.getElementById("myAudio").paused) {
        this.playing = false;
        this.myAudioSrc = null;
        document.getElementById("myAudio").pause();
      }

      if (this.polyline == null) {} else {
        this.scenicMapObj.remove(this.polyline);
      }
      this.polyline = new AMap.Polyline({
        path: this.lines[i].linePois, //设置线覆盖物路径
        strokeColor: "#f56b61", //线颜色
        strokeOpacity: 0.8, //线透明度
        strokeWeight: 3, //线宽
        strokeStyle: "solid", //线样式
        isOutline: true,
        borderWeight: 1,
        outlineColor: "#fff",
        lineJoin: "round",
        lineCap: "round",
        strokeDasharray: [10, 5], //补充线样式
        zIndex: 9999
      });
      this.polyline.setMap(this.scenicMapObj);
      this.curMarkers = this.lines[i].lineMarkers;
      this.scenicMapObj.add(this.curMarkers);
      this.isInLine = true;
      this.scenicMapObj.setFitView(this.curMarkers);
      this.activeLineSpotIdx = -1;
      this.swiperItemIndex = 0;
    },
    mapMoveEnd: function mapMoveEnd() {
      if (this.isInLine) {

        return;
      } else {

        this.addPoi();
      }
    },
    addPoi: function addPoi() {
      console.log("addPoi");
      this.scenicMapObj.remove(this.curMarkers);
      this.curMarkers = [];

      var zoom = this.scenicMapObj.getZoom();

      console.log(this.activePoiTypeId);
      for (var z in this.poiType[this.activePoiTypeIndex].types) {
        this.curMarkers = this.curMarkers.concat(this.poiType[this.activePoiTypeIndex].types[z].markerArr[this.scenicMapObj.getZoom() - this.mapMinZoom]);
      }
      console.log(this.curMarkers);
      this.scenicMapObj.add(this.curMarkers);
    },
    changeMarkerType: function changeMarkerType(i) {
      this.activePoiTypeId = i;

      if (this.isLineListShow) {

        this.isLineListShow = false;
        this.activeLineIdx = -1;
        if (this.isInLine) {
          this.isInLine = false;
          this.scenicMapObj.remove(this.polyline);
        }
      }

      this.activeScenicPoiData = null;
      if (!document.getElementById("myAudio").paused) {
        this.playing = false;
        this.myAudioSrc = null;
        document.getElementById("myAudio").pause();
      }

      this.addPoi();
    },
    showTalks: function showTalks() {
      if (this.activePoiTypeId == 1) {} else {
        this.activePoiTypeId = 1;
        this.addPoi();
      }
      this.isNearListShow = false;
    },
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    },
    onSwiperItemIndexChange: function onSwiperItemIndexChange(index) {
      console.log("demo item change", index);
      if (index != 0) {
        this.activeLineSpotIdx = index - 1;
        this.linePoiClick(this.lines[this.activeLineIdx].lineMarkers[this.activeLineSpotIdx].getPosition(), this.lines[this.activeLineIdx].lineMarkers[this.activeLineSpotIdx].getExtData().poiData);
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getScenicData();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {
    if (this.$route.query.hid != this.hid) {
      console.log("🚀 ~ file: Scenic.vue ~ line 880 ~ activated ~ activated");
      assign_default()(this.$data, this.$options.data.call(this));
      this.hid = this.$route.query.hid;
      this.$nextTick(function () {
        this.getScenicData();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Scenic/Scenic.vue







/* harmony default export */ var Scenic_Scenic = ({

  components: { PositionBtn: src_components_PositionBtn_PositionBtn, Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {

    return {
      hid: this.$route.query.hid,
      scenicData: null, //景区所有数据
      scenicMapObj: null, //地图实例
      leLayer: null,
      isleLayerShow: true, //瓦片是否展示
      isLocation: false, //是否展示当前定位了
      scenicBound: [], //电子围栏
      isInLine: false, //是否在线路中
      lines: [], //线路所有数据
      activeLineIdx: -1, //选中的线路下标
      activeLineSpotIdx: -1, //选中的线路的选中点的下标
      polyline: null, //线路中的线
      isNearListShow: false, //附近点列表是否展示
      mapMinZoom: 13,
      mapMaxZoom: 18,

      isLineListShow: false, //是否展示线路列表

      poiType: [],
      activePoiTypeId: null, //选中展示的poi类别
      scenicPoi: [],
      parkPoi: [],
      toiletPoi: [],
      catePoi: [],
      hotelPoi: [],
      shopPoi: [],
      servicePoi: [],
      curMarkers: [], //当前地图中的点位
      playing: false, //景点弹窗中音频播放状态
      activeScenicPoiData: null, //点击景点的数据
      myAudioSrc: null, //音频地址

      swiperItemIndex: 0

    };
  },


  computed: {
    activePoiTypeIndex: function activePoiTypeIndex() {
      if (this.poiType == null) {
        return null;
      } else {
        for (var i in this.poiType) {
          if (this.poiType[i].id == this.activePoiTypeId) {
            return i;
          }
        }
      }
    }
  },

  watch: {},

  methods: {
    getScenicData: function getScenicData() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
        params: { hid: that.hid },
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          that.scenicData = data.data.data.scenic;
          document.title = data.data.data.scenic.name;

          function getPoiList(Arr) {
            var zoomRange = parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom);
            for (var j = 0; j < zoomRange + 1; j++) {
              var arr = [];
              Arr.push(arr);
            }
          }

          that.setPoiType(data.data.data.navTabs);
          that.setPois(data.data.data.scenic.pointses);

          that.setMap();

          that.setLine(data.data.data.scenic.hotspotLinesList);
        }
      });
    },
    setMap: function setMap() {
      var that = this;

      that.scenicMapObj = new AMap.Map("scenicMap", {
        view: new AMap.View2D({

          center: new AMap.LngLat(that.scenicData.longitude, that.scenicData.latitude),
          zoom: that.scenicData.min_zoom, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });

      for (var i in that.scenicData.polygons) {
        that.scenicBound.push([that.scenicData.polygons[i].longitude, that.scenicData.polygons[i].latitude]);
      }

      var maipuLeLayerId = void 0;
      switch (parseInt(that.hid)) {
        case 18:
          maipuLeLayerId = 53004;
          break;
        case 17:
          maipuLeLayerId = 4249;
          break;
      }
      that.leLayer = new AMap.TileLayer({

        tileUrl: "https://tiles.worldmaipu.com/" + maipuLeLayerId + "/[z]/[x]_[y].png",
        zIndex: 2
      });
      that.leLayer.setMap(that.scenicMapObj);

      that.isLocation = true;
      that.scenicMapObj.on("complete", function () {
        console.log("地图加载完毕");
      });

      for (var j in that.poiType) {
        if (that.poiType[j].isHasPoi) {
          that.activePoiTypeId = that.poiType[j].id;

          break;
        }
      }
      console.log(that.poiType[that.activePoiTypeIndex]);
      for (var z in that.poiType[that.activePoiTypeIndex].types) {
        that.curMarkers = that.curMarkers.concat(that.poiType[that.activePoiTypeIndex].types[z].markerArr[that.scenicMapObj.getZoom() - that.mapMinZoom]);
        console.log(that.curMarkers);
      }
      console.log(that.curMarkers);
      if (that.curMarkers == undefined || that.curMarkers.length == 0) {} else {
        that.scenicMapObj.add(that.curMarkers);
      }

      AMap.event.addListener(that.scenicMapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.scenicMapObj.getZoom());
        that.mapMoveEnd();
      });

      AMap.event.addListener(that.scenicMapObj, "click", function (e) {
        console.log("点击地图");
        console.log(e.lnglat);
      });

      that.scenicMapObj.plugin(["AMap.ToolBar"], function () {
        that.scenicMapObj.addControl(new AMap.ToolBar({
          position: "LB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 200)
        }));
      });
    },
    setPoiType: function setPoiType(arr) {
      var that = this;
      for (var i in arr) {
        var obj = {};
        obj.id = arr[i].typeId;
        obj.name = arr[i].typeName;
        obj.icon = that.GLOBAL.DOMAIN_URL + arr[i].icon;
        obj.picth_icon = that.GLOBAL.DOMAIN_URL + arr[i].picthIcon;

        obj.types = [];
        for (var j in arr[i].navItems) {
          var sortObj = {};
          sortObj.pointIcon = that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointIcon;
          sortObj.id = arr[i].navItems[j].typeId;
          sortObj.pointPicthIcon = that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointPicthIcon;
          sortObj.markerArr = [];
          sortObj.typeName = arr[i].navItems[j].typeName;
          for (var z = that.mapMinZoom; z <= that.mapMaxZoom; z++) {
            sortObj.markerArr.push([]);
          }
          obj.types.push(sortObj);
        }
        obj.isHasPoi = false;
        that.poiType.push(obj);
      }
    },
    // 处理生成poi点 isScenicPoi是否是景点
    openLayer: function openLayer() {
      if (this.isleLayerShow == false) {
        this.leLayer.setMap(this.scenicMapObj);
      } else {
        this.scenicMapObj.remove(this.leLayer);
      }
      this.isleLayerShow = !this.isleLayerShow;
    },
    setPois: function setPois(pointses) {
      var that = this;

      var poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
      for (var i in pointses) {

        var max_zoom = pointses[i].max_zoom;

        var min_zoom = pointses[i].min_zoom;
        var icon_default = void 0;
        var typeIndex = void 0;
        var typeIdx = void 0;
        var isHasThisType = false;
        for (var j in that.poiType) {
          for (var z in that.poiType[j].types) {
            if (pointses[i].type == that.poiType[j].types[z].id) {
              icon_default = that.poiType[j].types[z].pointIcon;

              typeIndex = j;
              typeIdx = z;
              isHasThisType = true;
              that.poiType[j].isHasPoi = true;
              break;
            }
          }
        }

        if (!isHasThisType) {
          continue;
        }
        var marker = new AMap.Marker({
          position: new AMap.LngLat(pointses[i].longitude, pointses[i].latitude),
          content: "<div class='poi' id='poi" + i + "'><img class='iconall icon-default' src='" + icon_default + "'><span class='poiName'>" + pointses[i].chs_name + "</span></div>",
          offset: new AMap.Pixel(-23, -46),
          extData: {
            poiData: pointses[i]
          }
        });
        AMap.event.addListener(marker, "click", function (e) {
          this.setTop(true);

          that.poiMarkerFun(this);
        });
        var min = pointses[i].min_zoom - that.mapMinZoom;
        for (var _z = 0; _z < poiZoomRange + 1; _z++) {
          if (_z >= min) {
            that.poiType[typeIndex].types[typeIdx].markerArr[_z].push(marker);
          }
        }
      }
    },
    creatMarker: function creatMarker(point) {
      var that = this;
      var className = void 0;
      var offset = new AMap.Pixel(-16, -32);
      switch (Number(point.type)) {
        case 2:
          className = "talk";

          offset = new AMap.Pixel(-16, -16);
          break;
        case 9:
          className = "parking";
          break;
        case 6:
          className = "toilet";
          break;
        case 8:
          className = "cate";
          break;
        case 5:
          className = "hotel";
          break;
        case 12:
          className = "shopping";
          break;
        case 10:
          className = "service";
          break;
      }
      var thisPoi = new AMap.Marker({
        content: "<div class='poi'><div class='" + className + " iconall'></div><span class='poiName'>" + point.chs_name + "</span></div>",
        position: new AMap.LngLat(point.longitude, point.latitude),

        offset: offset,
        extData: {
          poiData: point
        }
      });
      return thisPoi;
    },
    poiMarkerFun: function poiMarkerFun(_this) {
      var that = this;
      var position = _this.getPosition();
      var extData = _this.getExtData();
      console.log(extData);

      if (that.activePoiTypeId == 1) {
        that.activeScenicPoiData = extData.poiData;
        that.playing = false;

        if (extData.poiData.audio != null) {
          that.myAudioSrc = that.GLOBAL.DOMAIN_URL + extData.poiData.audio.split(".")[0] + ".mp3";
        } else {
          that.myAudioSrc = null;
        }

        if (that.myAudioSrc != null) {
          document.getElementById("myAudio").load();
        }
      } else {

        console.log("poiMarkerFun -> extData.chs_name", extData.poiData.chs_name);
        console.log("poiMarkerFun -> " + sessionStorage.getItem("lat"));
        console.log("poiMarkerFun -> " + sessionStorage.getItem("lng"));
        console.log("poiMarkerFun -> extData.latitude", extData.poiData.latitude);
        console.log("poiMarkerFun -> extData.longitude", extData.poiData.longitude);
        that.nav(extData.poiData.chs_name, extData.poiData.latitude, extData.poiData.longitude);
      }
    },
    setLine: function setLine(linesList) {
      var that = this;
      for (var i in linesList) {
        var obj = {};
        obj.lineName = linesList[i].lineName;
        obj.lineDuration = linesList[i].reserved3;
        obj.lineSpots = linesList[i].reserved4;
        obj.id = linesList[i].id;
        obj.coordinateList = [];
        obj.linePois = [];
        obj.lineMarkers = [];
        var z = 1;
        for (var n in linesList[i].coordinateList) {
          obj.linePois.push(new AMap.LngLat(Number(linesList[i].coordinateList[n].longitude), Number(linesList[i].coordinateList[n].latitude)));
          if (linesList[i].coordinateList[n].reserved1.indexOf("默认") == -1) {

            obj.coordinateList.push(linesList[i].coordinateList[n]);
            var marker = new AMap.Marker({
              content: "<div class='line-poi'><div class='line-marker' number='" + n + "'>" + z + "</div><span class='poiName'>" + linesList[i].coordinateList[n].reserved1 + "</span></div>",
              position: new AMap.LngLat(linesList[i].coordinateList[n].longitude, linesList[i].coordinateList[n].latitude),

              offset: new AMap.Pixel(-23, -46),
              extData: {
                poiData: linesList[i].coordinateList[n],
                index: z - 1
              }
            });
            AMap.event.addListener(marker, "click", function (e) {
              var thisPosition = e.target.getPosition();
              var extData = e.target.getExtData().poiData;
              var index = e.target.getExtData().index;
              that.linePoiClick(thisPosition, extData, index);
              that.activeLineSpotIdx = index;
              that.swiperItemIndex = parseInt(index) + 1;
            });

            obj.lineMarkers.push(marker);
            z++;
          }
        }
        that.lines.push(obj);
      }
      console.log(that.lines);
    },
    linePoiClick: function linePoiClick(thisPosition, extData) {
      console.log(extData);
      this.playing = false;
      if (extData.audio != null) {
        this.myAudioSrc = this.GLOBAL.DOMAIN_URL + extData.audio.split(".")[0] + ".mp3";
      } else {
        this.myAudioSrc = null;
      }

      if (this.myAudioSrc != null) {
        document.getElementById("myAudio").load();
      }

      this.scenicMapObj.setCenter(thisPosition);
    },
    lineTrigger: function lineTrigger() {
      if (this.isLineListShow) {

        this.isLineListShow = false;
        this.activeLineIdx = -1;
        if (this.isInLine) {
          if (!document.getElementById("myAudio").paused) {
            document.getElementById("myAudio").pause();
            this.playing = false;
          }
          this.isInLine = false;
          this.scenicMapObj.remove(this.polyline);
          this.mapMoveEnd();
        }
      } else {

        this.isLineListShow = true;
      }
    },
    showLine: function showLine(i) {
      this.activeLineIdx = i;
      console.log(i);
      this.scenicMapObj.remove(this.curMarkers);

      this.activeScenicPoiData = null;
      if (!document.getElementById("myAudio").paused) {
        this.playing = false;
        this.myAudioSrc = null;
        document.getElementById("myAudio").pause();
      }

      if (this.polyline == null) {} else {
        this.scenicMapObj.remove(this.polyline);
      }
      this.polyline = new AMap.Polyline({
        path: this.lines[i].linePois, //设置线覆盖物路径
        strokeColor: "#f56b61", //线颜色
        strokeOpacity: 0.8, //线透明度
        strokeWeight: 3, //线宽
        strokeStyle: "solid", //线样式
        isOutline: true,
        borderWeight: 1,
        outlineColor: "#fff",
        lineJoin: "round",
        lineCap: "round",
        strokeDasharray: [10, 5], //补充线样式
        zIndex: 9999
      });
      this.polyline.setMap(this.scenicMapObj);
      this.curMarkers = this.lines[i].lineMarkers;
      this.scenicMapObj.add(this.curMarkers);
      this.isInLine = true;
      this.scenicMapObj.setFitView(this.curMarkers);
      this.activeLineSpotIdx = -1;
      this.swiperItemIndex = 0;
    },
    mapMoveEnd: function mapMoveEnd() {
      if (this.isInLine) {

        return;
      } else {

        this.addPoi();
      }
    },
    addPoi: function addPoi() {
      console.log("addPoi");
      this.scenicMapObj.remove(this.curMarkers);
      this.curMarkers = [];

      var zoom = this.scenicMapObj.getZoom();

      console.log(this.activePoiTypeId);
      for (var z in this.poiType[this.activePoiTypeIndex].types) {
        this.curMarkers = this.curMarkers.concat(this.poiType[this.activePoiTypeIndex].types[z].markerArr[this.scenicMapObj.getZoom() - this.mapMinZoom]);
      }
      console.log(this.curMarkers);
      this.scenicMapObj.add(this.curMarkers);
    },
    changeMarkerType: function changeMarkerType(i) {
      this.activePoiTypeId = i;

      if (this.isLineListShow) {

        this.isLineListShow = false;
        this.activeLineIdx = -1;
        if (this.isInLine) {
          this.isInLine = false;
          this.scenicMapObj.remove(this.polyline);
        }
      }

      this.activeScenicPoiData = null;
      if (!document.getElementById("myAudio").paused) {
        this.playing = false;
        this.myAudioSrc = null;
        document.getElementById("myAudio").pause();
      }

      this.addPoi();
    },
    showTalks: function showTalks() {
      if (this.activePoiTypeId == 1) {} else {
        this.activePoiTypeId = 1;
        this.addPoi();
      }
      this.isNearListShow = false;
    },
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    },
    onSwiperItemIndexChange: function onSwiperItemIndexChange(index) {
      console.log("demo item change", index);
      if (index != 0) {
        this.activeLineSpotIdx = index - 1;
        this.linePoiClick(this.lines[this.activeLineIdx].lineMarkers[this.activeLineSpotIdx].getPosition(), this.lines[this.activeLineIdx].lineMarkers[this.activeLineSpotIdx].getExtData().poiData);
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getScenicData();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {
    if (this.$route.query.hid != this.hid) {
      console.log("🚀 ~ file: Scenic.vue ~ line 880 ~ activated ~ activated");
      assign_default()(this.$data, this.$options.data.call(this));
      this.hid = this.$route.query.hid;
      this.$nextTick(function () {
        this.getScenicData();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1304708b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Scenic/Scenic.vue
var Scenic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('audio',{attrs:{"src":_vm.myAudioSrc,"id":"myAudio"}}),_vm._v(" "),_c('div',{attrs:{"id":"scenicMap"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNearListShow),expression:"!isNearListShow"}],staticClass:"lt-btns"},[_c('div',{class:['lt-btn leLayer', _vm.isleLayerShow ? 'on' : ''],on:{"click":function($event){return _vm.openLayer()}}}),_vm._v(" "),_c('div',{staticClass:"lt-btn near-poi",on:{"click":function($event){_vm.isNearListShow = true}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNearListShow),expression:"isNearListShow"}],staticClass:"near-box"},[_c('div',{staticClass:"show-lt-btns",on:{"click":function($event){return _vm.showTalks()}}}),_vm._v(" "),_c('ul',{staticClass:"near-list"},_vm._l((_vm.poiType),function(item,index){return (item.id != 1 && item.isHasPoi)?_c('li',{key:index,class:_vm.activePoiTypeId == item.id ? 'active' : '',on:{"click":function($event){return _vm.changeMarkerType(item.id)}}},[_c('img',{staticClass:"icon-poi",attrs:{"src":_vm.activePoiTypeId == item.id ? item.picth_icon : item.icon}}),_vm._v(" "),_c('span',{staticClass:"poi-type"},[_vm._v(_vm._s(item.name))])]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"rt-btns"},[(_vm.lines.length > 0)?_c('div',{class:['rt-btn line', _vm.isLineListShow ? 'on' : ''],on:{"click":function($event){return _vm.lineTrigger()}}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLineListShow),expression:"isLineListShow"}],staticClass:"line-list"},_vm._l((_vm.lines),function(item,index){return _c('li',{key:index,class:['line-item', _vm.activeLineIdx == index ? 'on' : ''],on:{"click":function($event){$event.stopPropagation();return _vm.showLine(index)}}},[_c('span',{staticClass:"line-num"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('span',{staticClass:"line-name"},[_vm._v("线路")])])}),0)]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"rt-btn global",attrs:{"to":"index"}})],1),_vm._v(" "),_c('PositionBtn',{attrs:{"isLocation":_vm.isLocation,"scenicBound":_vm.scenicBound,"mapObj":_vm.scenicMapObj}}),_vm._v(" "),(_vm.activeScenicPoiData != null)?_c('div',{staticClass:"talk-pop"},[_c('div',{staticClass:"talk-player",on:{"click":function($event){return _vm.playScenicAudio()}}},[_c('div',{class:['player-box', _vm.playing ? 'on' : ''],style:({
          'background-image':
            'url(' + _vm.GLOBAL.DOMAIN_URL + _vm.activeScenicPoiData.thumbImg + ')',
        })},[_c('i')])]),_vm._v(" "),_c('div',{staticClass:"talk-content"},[_c('router-link',{staticClass:"talk-name ellipsis-1",attrs:{"to":{ path: 'scenicDetail', query: { id: _vm.activeScenicPoiData.hid } }}},[_vm._v(_vm._s(_vm.activeScenicPoiData.chs_name))]),_vm._v(" "),_c('div',{staticClass:"nav",on:{"click":function($event){return _vm.nav(
            _vm.activeScenicPoiData.chs_name,
            _vm.activeScenicPoiData.latitude,
            _vm.activeScenicPoiData.longitude
          )}}},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',[_vm._v("导航")])])],1)]):_vm._e(),_vm._v(" "),(_vm.isInLine)?_c('div',{staticClass:"line-spots",attrs:{"id":"moveDiv"}},[_c('swiper',{attrs:{"show-dots":false},on:{"on-index-change":_vm.onSwiperItemIndexChange},model:{value:(_vm.swiperItemIndex),callback:function ($$v) {_vm.swiperItemIndex=$$v},expression:"swiperItemIndex"}},[_c('swiper-item',{staticClass:"line-first"},[_c('div',{staticClass:"line-box"},[_c('div',{staticClass:"first-content"},[_c('div',{staticClass:"line-name"},[_vm._v("\n              "+_vm._s(_vm.lines[_vm.activeLineIdx].lineName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"line-msg"},[_c('i',{staticClass:"icon-spots"}),_vm._v(" "),_c('span',{staticClass:"msg-spots"},[_vm._v(_vm._s(_vm.lines[_vm.activeLineIdx].lineSpots))]),_vm._v(" "),_c('i',{staticClass:"icon-time"}),_vm._v(" "),_c('span',{staticClass:"msg-time"},[_vm._v(_vm._s(_vm.lines[_vm.activeLineIdx].lineDuration))])]),_vm._v(" "),_c('div',{staticClass:"slider-tip"},[_c('i',{staticClass:"icon-slider"}),_vm._v(" "),_c('span',{staticClass:"slider-msg"},[_vm._v("滑动开始")])])])])]),_vm._v(" "),_vm._l((_vm.lines[_vm.activeLineIdx].coordinateList),function(item,index){return _c('swiper-item',{key:index,staticClass:"line-spot"},[_c('div',{staticClass:"line-box"},[_c('div',{staticClass:"line-spot-content"},[_c('div',{staticClass:"talk-player",on:{"click":function($event){$event.stopPropagation();return _vm.playScenicAudio()}}},[_c('div',{class:['player-box', _vm.playing ? 'on' : ''],style:({
                  'background-image':
                    'url(' + _vm.GLOBAL.DOMAIN_URL + item.thumb_img + ')',
                })},[_c('i')])]),_vm._v(" "),_c('div',{staticClass:"talk-content"},[_c('router-link',{staticClass:"talk-name ellipsis-1",attrs:{"to":{
                  path: 'scenicDetail',
                  query: { id: item.reserved2 },
                }}},[_vm._v(_vm._s(item.reserved1))]),_vm._v(" "),_c('div',{staticClass:"nav",on:{"click":function($event){$event.stopPropagation();return _vm.nav(item.reserved1, item.latitude, item.longitude)}}},[_c('i',{staticClass:"icon-nav"}),_vm._v(" "),_c('span',[_vm._v("导航")])])],1)])])])})],2)],1):_vm._e()],1)}
var Scenic_staticRenderFns = []
var Scenic_esExports = { render: Scenic_render, staticRenderFns: Scenic_staticRenderFns }
/* harmony default export */ var pages_Scenic_Scenic = (Scenic_esExports);
// CONCATENATED MODULE: ./src/pages/Scenic/Scenic.vue
function Scenic_injectStyle (ssrContext) {
  __webpack_require__("9i8G")
  __webpack_require__("n0At")
}
var Scenic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Scenic___vue_template_functional__ = false
/* styles */
var Scenic___vue_styles__ = Scenic_injectStyle
/* scopeId */
var Scenic___vue_scopeId__ = "data-v-1304708b"
/* moduleIdentifier (server only) */
var Scenic___vue_module_identifier__ = null
var Scenic_Component = Scenic_normalizeComponent(
  Scenic_Scenic,
  pages_Scenic_Scenic,
  Scenic___vue_template_functional__,
  Scenic___vue_styles__,
  Scenic___vue_scopeId__,
  Scenic___vue_module_identifier__
)

/* harmony default export */ var src_pages_Scenic_Scenic = (Scenic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Author/Author.vue
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var Author = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    var that = this;
    var code = that.commonFun.getUrlCode().code;
    console.log(code);
    if (code) {
      //如果连接中能拿到code说明此时access_token没有或者已过期，需要重新获取token
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/web_oauth!GetUserInfoV.action",
        params: { code: code },
        success: function success(data) {
          console.log(data);
          // debugger
          if (data.data.member) {
            that.commonFun.setCookie("member_id", data.data.member.id);
            that.commonFun.setCookie("member_head", data.data.member.midImg);
            that.commonFun.setCookie("member_nick_name", data.data.member.nickName);
          }
          // if (data == undefined) {
          //   //   code过期或者什么问题
          // } else {

          //   that.commonFun.setCookie("member_id", data.member.member_id);
          //   that.commonFun.setCookie("member_head",that.GLOBAL.DOMAIN_URL+data.member.big_img);
          //   that.commonFun.setCookie("member_nick_name", data.member.nick_name);

          // }
          var url = sessionStorage.getItem("beforeUrl");
          //跳转
          that.$router.push(url);
        }
      });
    }
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Author/Author.vue
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var Author_Author = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {};
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {
    var that = this;
    var code = that.commonFun.getUrlCode().code;
    console.log(code);
    if (code) {
      //如果连接中能拿到code说明此时access_token没有或者已过期，需要重新获取token
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/web_oauth!GetUserInfoV.action",
        params: { code: code },
        success: function success(data) {
          console.log(data);
          // debugger
          if (data.data.member) {
            that.commonFun.setCookie("member_id", data.data.member.id);
            that.commonFun.setCookie("member_head", data.data.member.midImg);
            that.commonFun.setCookie("member_nick_name", data.data.member.nickName);
          }
          // if (data == undefined) {
          //   //   code过期或者什么问题
          // } else {

          //   that.commonFun.setCookie("member_id", data.member.member_id);
          //   that.commonFun.setCookie("member_head",that.GLOBAL.DOMAIN_URL+data.member.big_img);
          //   that.commonFun.setCookie("member_nick_name", data.member.nick_name);

          // }
          var url = sessionStorage.getItem("beforeUrl");
          //跳转
          that.$router.push(url);
        }
      });
    }
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eca9231","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Author/Author.vue
var Author_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{})}
var Author_staticRenderFns = []
var Author_esExports = { render: Author_render, staticRenderFns: Author_staticRenderFns }
/* harmony default export */ var pages_Author_Author = (Author_esExports);
// CONCATENATED MODULE: ./src/pages/Author/Author.vue
function Author_injectStyle (ssrContext) {
  __webpack_require__("P/sb")
}
var Author_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Author___vue_template_functional__ = false
/* styles */
var Author___vue_styles__ = Author_injectStyle
/* scopeId */
var Author___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Author___vue_module_identifier__ = null
var Author_Component = Author_normalizeComponent(
  Author_Author,
  pages_Author_Author,
  Author___vue_template_functional__,
  Author___vue_styles__,
  Author___vue_scopeId__,
  Author___vue_module_identifier__
)

/* harmony default export */ var src_pages_Author_Author = (Author_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Near/Near.vue
var Near = __webpack_require__("Cjcp");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Near/Near.vue
var Near_Near = __webpack_require__("aXgj");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c792ec7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Near/Near.vue
var Near_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"typeList"},[_c('div',{class:['typeItem', _vm.activeType == 0 ? 'on' : ''],on:{"click":function($event){return _vm.changType(0)}}},[_vm._v("\n      卫生间\n    ")]),_vm._v(" "),_c('div',{class:['typeItem', _vm.activeType == 1 ? 'on' : ''],on:{"click":function($event){return _vm.changType(1)}}},[_vm._v("\n      停车场\n    ")]),_vm._v(" "),_c('div',{class:['typeItem', _vm.activeType == 2 ? 'on' : ''],on:{"click":function($event){return _vm.changType(2)}}},[_vm._v("\n      美食\n    ")]),_vm._v(" "),_c('div',{class:['typeItem', _vm.activeType == 3 ? 'on' : ''],on:{"click":function($event){return _vm.changType(3)}}},[_vm._v("\n      住宿\n    ")])]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"container"}}),_vm._v(" "),_c('div',{staticClass:"back-btn",on:{"click":function($event){return _vm.$router.go(-1)}}}),_vm._v(" "),_c('div',{staticClass:"toilet-list"},[(_vm.toiletPois != null && _vm.toiletPois.length > 0)?_c('ul',{staticClass:"toilet-box",attrs:{"id":"toiletBox"}},_vm._l((_vm.toiletPois),function(item,index){return _c('li',{key:item.id,class:['toilet-item', 'vux-1px-b', _vm.walkIdx == index ? 'on' : '']},[_c('div',{staticClass:"toilet-content",on:{"click":function($event){return _vm.drawWlak(item, index)}}},[_c('div',{staticClass:"toilet-name"},[_vm._v("\n            "+_vm._s(item.name)+"\n            "),(_vm.walkIdx == index)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("（步行规划线路展示中）")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"toilet-dis-add"},[_c('span',{staticClass:"toilet-dis"},[_vm._v(_vm._s(item.distance)+"米")]),_vm._v(" "),(item.address.length != 0)?_c('span',{staticClass:"toilet-add ellipsis-1"},[_vm._v(_vm._s(item.address))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"toilet-nav",on:{"click":function($event){_vm.nav(
              item.name,
              item.location.split(',')[1],
              item.location.split(',')[0]
            )}}},[_c('i',{}),_vm._v(" "),_c('span',[_vm._v("导航")])])])}),0):(_vm.toiletPois == null)?_c('div',{staticClass:"toilet-box-no"},[_vm._v("\n      定位中。。。\n    ")]):_c('div',{staticClass:"toilet-box-no"},[_vm._v("没有结果")])])])}
var Near_staticRenderFns = []
var Near_esExports = { render: Near_render, staticRenderFns: Near_staticRenderFns }
/* harmony default export */ var pages_Near_Near = (Near_esExports);
// CONCATENATED MODULE: ./src/pages/Near/Near.vue
function Near_injectStyle (ssrContext) {
  __webpack_require__("qjMm")
  __webpack_require__("Do6p")
}
var Near_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Near___vue_template_functional__ = false
/* styles */
var Near___vue_styles__ = Near_injectStyle
/* scopeId */
var Near___vue_scopeId__ = "data-v-c792ec7a"
/* moduleIdentifier (server only) */
var Near___vue_module_identifier__ = null
var Near_Component = Near_normalizeComponent(
  Near_Near["a" /* default */],
  pages_Near_Near,
  Near___vue_template_functional__,
  Near___vue_styles__,
  Near___vue_scopeId__,
  Near___vue_module_identifier__
)

/* harmony default export */ var src_pages_Near_Near = (Near_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ScenicDetail/ScenicDetail.vue





/* harmony default export */ var ScenicDetail = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {

    return {
      id: this.$route.query.id,
      hotspot: null,
      imgList: [],
      myAudioSrc: null,
      playing: false
    };
  },


  computed: {},

  watch: {},

  methods: {
    getDetail: function getDetail() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getHotspotInfo.action",
        params: { id: that.id },
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          that.hotspot = data.data.hotspot;
          that.imgList = data.data.imgList;
          document.title = data.data.hotspot.name;

          if (data.data.hotspot.audio != null) {
            that.myAudioSrc = that.GLOBAL.DOMAIN_URL + data.data.hotspot.audio.split('.')[0] + '.mp3';
          }

          that.$nextTick(function () {
            if (that.myAudioSrc != null) {
              document.getElementById("scenicAudio").load();
            }
          });
        }
      });
    },
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("scenicAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getDetail();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ScenicDetail/ScenicDetail.vue





/* harmony default export */ var ScenicDetail_ScenicDetail = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {

    return {
      id: this.$route.query.id,
      hotspot: null,
      imgList: [],
      myAudioSrc: null,
      playing: false
    };
  },


  computed: {},

  watch: {},

  methods: {
    getDetail: function getDetail() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getHotspotInfo.action",
        params: { id: that.id },
        isShowLoading: true,
        success: function success(data) {
          console.log(data);
          that.hotspot = data.data.hotspot;
          that.imgList = data.data.imgList;
          document.title = data.data.hotspot.name;

          if (data.data.hotspot.audio != null) {
            that.myAudioSrc = that.GLOBAL.DOMAIN_URL + data.data.hotspot.audio.split('.')[0] + '.mp3';
          }

          that.$nextTick(function () {
            if (that.myAudioSrc != null) {
              document.getElementById("scenicAudio").load();
            }
          });
        }
      });
    },
    playScenicAudio: function playScenicAudio() {
      var that = this;
      var audio = document.getElementById("scenicAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getDetail();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d1954c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ScenicDetail/ScenicDetail.vue
var ScenicDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hotspot)?_c('div',{staticClass:"page"},[_c('audio',{attrs:{"src":_vm.myAudioSrc,"id":"scenicAudio"}}),_vm._v(" "),_c('div',{staticClass:"swiper-box"},[_c('i',{staticClass:"icon-back",on:{"click":function($event){return _vm.$router.go(-1)}}}),_vm._v(" "),_c('div',{staticClass:"title-box"},[_c('span',{staticClass:"scenic-title"},[_vm._v(_vm._s(_vm.hotspot.name))]),_vm._v(" "),_c('i',{class:['icon-audio',_vm.playing?'play':''],on:{"click":function($event){return _vm.playScenicAudio()}}})]),_vm._v(" "),_c('swiper',{attrs:{"aspect-ratio":420/750,"loop":true,"auto":true,"show-dots":false}},_vm._l((_vm.imgList),function(item,index){return _c('swiper-item',{key:index},[_c('img',{staticClass:"swiper-img",attrs:{"src":_vm.GLOBAL.DOMAIN_URL+item.midImg,"alt":""}})])}),1)],1),_vm._v(" "),_c('div',{staticClass:"detail-box"},[_c('div',{staticClass:"section-title vux-1px-b"},[_vm._v("简介")]),_vm._v(" "),_c('div',{staticClass:"detail-content",domProps:{"innerHTML":_vm._s(_vm.hotspot.description)}},[_vm._v(_vm._s(_vm.hotspot.description))])])]):_vm._e()}
var ScenicDetail_staticRenderFns = []
var ScenicDetail_esExports = { render: ScenicDetail_render, staticRenderFns: ScenicDetail_staticRenderFns }
/* harmony default export */ var pages_ScenicDetail_ScenicDetail = (ScenicDetail_esExports);
// CONCATENATED MODULE: ./src/pages/ScenicDetail/ScenicDetail.vue
function ScenicDetail_injectStyle (ssrContext) {
  __webpack_require__("luc0")
  __webpack_require__("U88v")
}
var ScenicDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ScenicDetail___vue_template_functional__ = false
/* styles */
var ScenicDetail___vue_styles__ = ScenicDetail_injectStyle
/* scopeId */
var ScenicDetail___vue_scopeId__ = "data-v-c4d1954c"
/* moduleIdentifier (server only) */
var ScenicDetail___vue_module_identifier__ = null
var ScenicDetail_Component = ScenicDetail_normalizeComponent(
  ScenicDetail_ScenicDetail,
  pages_ScenicDetail_ScenicDetail,
  ScenicDetail___vue_template_functional__,
  ScenicDetail___vue_styles__,
  ScenicDetail___vue_scopeId__,
  ScenicDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_ScenicDetail_ScenicDetail = (ScenicDetail_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


 //主页
 //子页面
 //微信授权页面
 //附近搜索的点
 //景点详情


vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
var router_router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: {
      path: '/index'
    }
  }, {
    path: '/index',
    name: 'index',
    component: src_pages_Index_Index,
    meta: {
      keepAlive: false, title: '前童镇全域旅游导览'
    }
  }, {
    path: '/scenic',
    name: 'scenic',
    component: src_pages_Scenic_Scenic,
    meta: {
      keepAlive: true, title: ''
    }
  }, {
    path: '/author',
    name: 'author',
    component: src_pages_Author_Author,
    meta: {
      keepAlive: false
    }
  }, {
    path: '/near',
    name: 'near',
    component: src_pages_Near_Near,
    meta: {
      keepAlive: false, title: '附近'
    }
  }, {
    path: '/scenicDetail',
    name: 'scenicDetail',
    component: src_pages_ScenicDetail_ScenicDetail,
    meta: {
      keepAlive: false, title: ''
    }
  }]
});

/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//

// 初始化用户id

// import wx from "@/assets/utils/wx.js";
/* harmony default export */ var App = ({
  name: "app",
  components: {
    Map: map_default.a
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  provide: function provide() {
    return {
      reload: this.reload
    };
  },

  mothods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created: function created() {
    // 微信jssdk 配置
    // wx.wxConfig(
    //   false,
    //   {
    //     title: "", // 分享标题
    //     link: window.location.href, // 分享链接
    //     desc: "", // 分享描述
    //     imgUrl: "", // 分享图标
    //   },
    //   function () {
    //     //分享成功后的回调函数
    //     console.log("分享成功");
    //   }
    // );
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//

// 初始化用户id

// import wx from "@/assets/utils/wx.js";
/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  components: {
    Map: map_default.a
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  provide: function provide() {
    return {
      reload: this.reload
    };
  },

  mothods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created: function created() {
    // 微信jssdk 配置
    // wx.wxConfig(
    //   false,
    //   {
    //     title: "", // 分享标题
    //     link: window.location.href, // 分享链接
    //     desc: "", // 分享描述
    //     imgUrl: "", // 分享图标
    //   },
    //   function () {
    //     //分享成功后的回调函数
    //     console.log("分享成功");
    //   }
    // );
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d4b461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dPqm")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./src/common/js/commonFun.js


/* harmony default export */ var commonFun = ({

  getGreatCircleDistance: function getGreatCircleDistance(lat1, lng1, lat2, lng2) {
    var EARTH_RADIUS = 6378137.0;
    var PI = Math.PI;

    function getRad(d) {
      return d * PI / 180.0;
    }
    var radLat1 = getRad(lat1);
    var radLat2 = getRad(lat2);

    var a = radLat1 - radLat2;
    var b = getRad(lng1) - getRad(lng2);

    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;

    return s;
  },

  openLocation: function openLocation(name, lat1, lng1, lat2, lng2) {

    var url = "http://uri.amap.com/navigation//uri.amap.com/navigation?from=" + lng1 + "," + lat1 + ",我的位置&to=" + lng2 + "," + lat2 + "," + name + "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0";
    window.location.href = url;
  },
  getCookie: function getCookie(c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  setCookie: function setCookie(name, value, time) {
    if (arguments.length == 2) {
      var Days = 7;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + escape(value) + "; expires=" + exp.toGMTString();
    } else {
      var strsec = getsec(time);
      var _exp = new Date();
      _exp.setTime(_exp.getTime() + strsec * 1);
      document.cookie = name + "=" + escape(value) + ";expires=" + _exp.toGMTString();
    }
  },
  getsec: function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else {
      if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
      } else {
        if (str2 == "d") {
          return str1 * 24 * 60 * 60 * 1000;
        }
      }
    }
  },
  GetQueryString: function GetQueryString(name) {
    var url = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var newUrl = window.location.search.substr(1).match(url);
    if (newUrl != null) {
      return unescape(newUrl[2]);
    } else {
      return false;
    }
  },
  getUrlCode: function getUrlCode() {
    // 截取url中的code方法
    var url = location.search;
    this.winUrl = url;
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
    return theRequest;
  },

  /**
  * 音频播放时间换算
  * @param {number} value - 音频当前播放时间，单位秒
  */
  transTime: function transTime(value) {
    var time = "";
    var h = parseInt(value / 3600);
    value %= 3600;
    var m = parseInt(value / 60);
    var s = parseInt(value % 60);
    if (h > 0) {
      time = this.formatTime(h + ":" + m + ":" + s);
    } else {
      time = this.formatTime(m + ":" + s);
    }

    return time;
  },


  /**
  * 格式化时间显示，补零对齐
  * eg：2:4  -->  02:04
  * @param {string} value - 形如 h:m:s 的字符串
  */
  formatTime: function formatTime(value) {
    var time = "";
    var s = value.split(':');
    var i = 0;
    for (; i < s.length - 1; i++) {
      time += s[i].length == 1 ? "0" + s[i] : s[i];
      time += ":";
    }
    time += s[i].length == 1 ? "0" + s[i] : s[i];

    return time;
  },
  trim: function trim(string) {
    return string.replace(/(^\s*)|(\s*$)/g, '');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  BASE_URL = "https://qiantong.worldmaipu.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  BASE_URL = "/api";
}
var DOMAIN_URL = "https://qiantong.worldmaipu.com/"; //资源域名地址
// const DOMAIN_URL = "http://192.168.1.18:8080/"; //资源域名地址

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var isWx = u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

/* harmony default export */ var global = ({
  BASE_URL: BASE_URL, //接口地址
  DOMAIN_URL: DOMAIN_URL, //静态文件域名
  isAndroid: isAndroid, //是否在安卓
  isIos: isIos, //是否在ios
  isWx: isWx, //是否在微信
  isPc: isPc //是否在pc
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var global_BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  global_BASE_URL = "https://qiantong.worldmaipu.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  global_BASE_URL = "/api";
}
var global_DOMAIN_URL = "https://qiantong.worldmaipu.com/"; //资源域名地址
// const DOMAIN_URL = "http://192.168.1.18:8080/"; //资源域名地址

var global_u = navigator.userAgent;
var global_isAndroid = global_u.indexOf("Android") > -1 || global_u.indexOf("Adr") > -1; //android终端
var global_isIos = !!global_u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var global_isWx = global_u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var global_isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

/* harmony default export */ var components_global = ({
  BASE_URL: global_BASE_URL, //接口地址
  DOMAIN_URL: global_DOMAIN_URL, //静态文件域名
  isAndroid: global_isAndroid, //是否在安卓
  isIos: global_isIos, //是否在ios
  isWx: global_isWx, //是否在微信
  isPc: global_isPc //是否在pc
});
// CONCATENATED MODULE: ./src/components/global.vue
var global_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var global___vue_template_functional__ = false
/* styles */
var global___vue_styles__ = null
/* scopeId */
var global___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var global___vue_module_identifier__ = null
var global_Component = global_normalizeComponent(
  components_global,
  __vue_template__,
  global___vue_template_functional__,
  global___vue_styles__,
  global___vue_scopeId__,
  global___vue_module_identifier__
)

/* harmony default export */ var src_components_global = (global_Component.exports);

// CONCATENATED MODULE: ./src/main.js

















vue_esm["a" /* default */].prototype.commonFun = commonFun;
vue_esm["a" /* default */].use(animate_default.a);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);

vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(src_router);

/**
* 定义常量
*/



vue_esm["a" /* default */].prototype.GLOBAL = src_components_global;
console.log(vue_esm["a" /* default */].prototype.GLOBAL);

var loginTimeOutErrorCode = 'login_timeout_error';

/**
* 定义全局公用常量
*/

/**
* 定义全局公用方法
*/
vue_esm["a" /* default */].prototype.http = function (opts) {
  var vue = this;
  if (opts.isShowLoading) {
    vue.$vux.loading.show({
      text: '加载中...'
    });
  }

  vue.$http({
    method: opts.method,
    url: opts.url,
    headers: opts.headers || {},
    params: opts.params || {},
    data: opts.data || {}
  }).then(function (response) {
    vue.$vux.loading.hide();

    opts.success(response.data);
  }).catch(function (error) {
    vue.$vux.loading.hide();
    console.log(error);
    if (!opts.error) {
      console.log(!opts.error);
      var response = error.response;
      var errorMessage = response.statusText;
      console.log(response);
      console.log(errorMessage);

      vue.$vux.alert.show({
        title: '提示',
        content: errorMessage

      });
    } else {
      console.log(opts.error(error.response.data.data));
      opts.error(error.response.data.data);
    }
  });
};

vue_esm["a" /* default */].prototype.get = function (opts) {
  opts.method = 'get';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.post = function (opts) {
  opts.method = 'post';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.put = function (opts) {
  opts.method = 'put';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.delete = function (opts) {
  opts.method = 'delete';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.valid = function (opts) {
  var vue = this;
  var valid = true;

  if (opts.ref && !opts.ref.valid) {
    valid = false;
  }

  if (opts.ignoreRefs) {
    var newRefs = [];
    for (var i in opts.refs) {
      var ref = opts.refs[i];
      for (var j in opts.ignoreRefs) {
        var ignoreRef = opts.ignoreRefs[j];
        if (ref !== ignoreRef) {
          newRefs.push(ref);
        }
      }
    }
    opts.refs = newRefs;
  }

  for (var _i in opts.refs) {
    if (!opts.refs[_i].valid) {
      valid = false;
      break;
    }
  }

  if (valid) {
    opts.success();
  } else if (opts.error) {
    opts.error();
  } else {
    vue.$vux.toast.show({
      text: '请检查输入'
    });
  }
};

vue_esm["a" /* default */].config.productionTip = false;

src_router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "P/sb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U88v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aXgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AMap__ = __webpack_require__("+aT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_AMap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ __webpack_exports__["a"] = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data: function data() {
    //这里存放数据
    return {
      // 地图start
      activeType: 0, //当前搜索类别的下标
      types: ["200300", //卫生间
      "150900", //停车场
      "050000", //美食
      //  "050000|050100|050101|050102|050103|050104|050105|050106|050107|050108|050109|050110|050111|050112|050113|050114|050115|050116|050117|050118|050119|050120|050121|050122|050123|050200|050201|050202|050203|050204|050205|050206|050207|050208|050209|050210|050211|050212|050213|050214|050215|050216|050217|050300|050301|050302|050303|050304|050305|050306|050307|050308|050309|050310|050311|050400|050500|050501|050502|050503|050504|050600|050700|050800|050900", //美食
      "100000"], //搜索的类别
      curMarkers: [], //当前点的合集
      mapObj: null, //地图实例
      leLayer: null, //瓦片实例
      mapMaxZoom: 19, //地图最大层级
      mapMinZoom: 13, //地图最小层级
      geolocation: null, //定位组件
      isLocation: false, //是否展示当前定位了
      locationMarker: null, //当前定位marker点
      toiletPois: null, //厕所点集合
      walk: null, //线路规划
      walkIdx: -1 //线路规划中的poi点的下标
      // 地图end
    };
  },

  //监听属性 类似于data概念
  computed: {
    // toiletPois: function() {}
  },
  //监控data中的数据变化
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // toiletPois: function(newV, oldV) {
    //     console.log('变化咯。。。。。。。。。')
    // }
  },
  //方法集合
  methods: {
    //   地图初始化
    initMap: function initMap() {
      var that = this;
      // 创建地图实例
      that.mapObj = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Map("container", {
        view: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.View2D({
          //创建地图二维视口
          // center: new AMap.LngLat(
          //   sessionStorage.getItem("lng"),
          //   sessionStorage.getItem("lat")
          // ),
          zoom: 16, //设置地图缩放级别
          rotation: 0 //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn" //设置地图语言类型，默认：中文简体
      });
      // 瓦片加载
      that.leLayer = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl: "https://daoyou.worldmaipu.com" + "/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" + that.hid,
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]',
        // 'https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]&hid=',
        zIndex: 2
      });
      //   that.leLayer.setMap(that.mapObj);
      // 缩放组件
      // that.mapObj.plugin(["AMap.ToolBar"], function() {
      //   that.mapObj.addControl(
      //     new AMap.ToolBar({
      //       position: "RB",
      //       //locate:true
      //       liteStyle: true,
      //       offset: new AMap.Pixel(10, 100)
      //     })
      //   );
      // });

      // if (that.GLOBAL.isWx) {
      //   // 微信环境
      //   setTimeout(() => {
      //     that.wxGetLocationOnce();
      //   }, 600);
      // } else {
      //   // 普通浏览器环境
      //   that.geolocation = new qq.maps.Geolocation(
      //     "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
      //     "myweb"
      //   );
      //   // 初始默认持续获取当前定位
      //   that.watchCurPosition();
      // }
      that.geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 初始默认持续获取当前定位
      that.watchCurPosition();
    },

    // 持续获取当前定位
    watchCurPosition: function watchCurPosition() {
      console.log("on");
      var that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        that.clearWatchCurPosition();
        console.log(position);
        var lnglat = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(position.lng, position.lat);
        that.mapObj.setCenter(lnglat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        console.log(lnglat);
        if (that.isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.isLocation = true;
          that.locationMarker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
            position: lnglat,
            offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 101
          });
          that.mapObj.add(that.locationMarker);
        }
        that.searchToilet(position.lat, position.lng, that.activeType);
      }
    },

    // 微信中获取一次定位
    wxGetLocationOnce: function wxGetLocationOnce() {
      var that = this;
      this.$wechat.getLocation({
        type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
        success: function success(res) {
          // success
          console.log(res);
          var lat = res.latitude;
          var lng = res.longitude;
          // let lat = 36.195606;
          // let lng = 113.589566;
          var lnglat = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(lng, lat);
          sessionStorage.setItem("lng", lng);
          sessionStorage.setItem("lat", lat);
          if (that.isLocation) {
            that.locationMarker.setPosition(lnglat);
          } else {
            that.isLocation = true;
            that.locationMarker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
              position: lnglat,
              offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-8, -16),
              content: "<div class='curMarker'></div>",
              zIndex: 101
            });
            that.mapObj.add(that.locationMarker);
          }
          that.searchToilet(lat, lng, that.activeType);
        },
        fail: function fail() {
          // fail
        },
        complete: function complete() {
          // complete
        }
      });
    },

    // 停止获取当前定位
    clearWatchCurPosition: function clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      // this.mapObj.remove(this.locationMarker);
      // this.isLocation = false;
      // this.locationMarker = null;
    },


    //   搜索厕所poi
    searchToilet: function searchToilet(lat, lng, typeIndex) {
      var that = this;
      if (that.curMarkers.length > 0) {
        that.mapObj.remove(that.curMarkers);
        that.curMarkers = [];
      }
      var searchTypes = void 0;

      searchTypes = that.types[typeIndex];
      console.log(searchTypes);

      $.getJSON("https://restapi.amap.com/v3/place/around", {
        key: "c2526cf60981aa9faf0d2a8bab1b67bc",
        radius: 30000,
        types: that.types[typeIndex],
        location: lng + "," + lat,
        output: "JSON"
      }, function (res) {
        console.log(res);
        that.toiletPois = res.pois;
        that.setToiletPois(that.toiletPois, that.activeType);
        that.$nextTick(function () {
          document.getElementById("toiletBox").scrollTop = 0;
        });
      });
    },
    changType: function changType(i) {
      if (this.activeType == i) {
        return;
      } else {
        if (this.walk) {
          this.walk.clear();
        }
        this.walkIdx = -1;
        this.searchToilet(sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), i);
        this.activeType = i;
      }
    },
    setToiletPois: function setToiletPois(arr, type) {
      var that = this;
      var contentHtml = "";
      switch (parseInt(type)) {
        case 0:
          contentHtml = "<div class='search-toilet'></div>";
          break;
        case 1:
          contentHtml = "<div class='search-park'></div>";

          break;
        case 2:
          contentHtml = "<div class='gas-station'></div>";

          break;
        case 3:
          contentHtml = "<div class='search-stop'></div>";
          break;
        case 4:
          contentHtml = "<div class='search-hospital'></div>";
          break;
      }
      for (var i in arr) {
        var marker = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Marker({
          // map: that.mapObj,
          position: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.LngLat(arr[i].location.split(",")[0], arr[i].location.split(",")[1]),
          offset: new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Pixel(-16, -32),
          content: contentHtml,
          extData: {
            index: i
          }
        });
        // that.mapObj.add(marker);
        __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.event.addListener(marker, "click", function (e) {
          that.walkIdx = e.target.getExtData().index;
          var lat = e.target.getPosition().lat;
          var lng = e.target.getPosition().lng;
          __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.service("AMap.Walking", function () {
            if (that.walk) {
              that.walk.clear();
            }
            that.walk = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Walking({
              map: that.mapObj
              //用于显示路线指引信息的Div容器的id或Div元素
              //panel: "panel"
            });
            // 根据起终点经纬度规划驾车导航路线
            that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
              // console.log(result);
              if (status === "complete" && result.info === "OK") {
                that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
              }
            });
          });
          console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
          // 规划中的厕所点的对应dom滚动到顶部
          document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
        });
        that.curMarkers.push(marker);
      }
      that.mapObj.add(that.curMarkers);
      that.mapObj.setFitView();
    },

    // 规划线路 和点位点击事件相同
    drawWlak: function drawWlak(item, i) {
      var that = this;
      that.walkIdx = i;
      var lat = item.location.split(",")[1];
      var lng = item.location.split(",")[0];
      __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.service("AMap.Walking", function () {
        if (that.walk) {
          that.walk.clear();
        }
        that.walk = new __WEBPACK_IMPORTED_MODULE_0_AMap___default.a.Walking({
          map: that.mapObj
          //用于显示路线指引信息的Div容器的id或Div元素
          //panel: "panel"
        });
        // 根据起终点经纬度规划驾车导航路线
        that.walk.search([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")], [lng, lat], function (status, result) {
          // console.log(result);
          if (status === "complete" && result.info === "OK") {
            that.mapObj.setCenter([sessionStorage.getItem("lng"), sessionStorage.getItem("lat")]);
          }
        });
      });
      console.log(document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop);
      // 规划中的厕所点的对应dom滚动到顶部
      document.getElementById("toiletBox").scrollTop = document.getElementsByClassName("toilet-item")[that.walkIdx].offsetTop;
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, sessionStorage.getItem("lat"), sessionStorage.getItem("lng"), lat, lng);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    this.initMap();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "dPqm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "luc0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZdaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("qJoR")
}
var alert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (alert_Component.exports);


/***/ }),

/***/ "n0At":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJoR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qjMm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ruXm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ruXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "woim":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.94c5be7224f583ac1868.js